import {
  faEye,
  faPen,
  faTrash,
  faDownload,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useNavigate } from "react-router-dom";
import downloadHandler from "@serie3/freelancesplaceapi/Domain/Shared/downloadHandler";
import { useState } from "react";
import PDFModal from "../Popups/PDFModal";
import { btn, btnHoverStyle } from "./buttonStyles";

const EditCardButtons = ({
  index,
  data,
  setShowDetails,
  setViewData,
  deleteData,
  editUrl,
  downloadUrl,
  downloadname,
}) => {
  const navigate = useNavigate();
  const [showSpinner, setShowSpinner] = useState(false);

  const iconBtn = (variant) => ({ ...btn.base, ...btn.icon, ...variant });

  return (
    <>
      <style>{btnHoverStyle}</style>
      <PDFModal showSpinner={showSpinner} setShowSpinner={setShowSpinner} />
      <div style={{ display: "inline-flex", gap: "6px", alignItems: "center" }}>
        {downloadUrl ? (
          <button
            className="btn-modern"
            style={iconBtn(btn.iconSoft("#e8f0fe", "#1a73e8"))}
            onClick={() => {
              setShowSpinner(true);
              downloadHandler(downloadUrl, downloadname, null, setShowSpinner);
            }}
          >
            <FontAwesomeIcon icon={faDownload} />
          </button>
        ) : null}
        {setShowDetails ? (
          <button
            className="btn-modern"
            style={iconBtn(btn.iconSoft("#e8f0fe", "#1a73e8"))}
            onClick={() => {
              setViewData(data);
              setShowDetails(true);
            }}
          >
            <FontAwesomeIcon icon={faEye} />
          </button>
        ) : null}
        {editUrl ? (
          <button
            className="btn-modern"
            style={iconBtn(btn.iconSoft("#e8f0fe", "#1a73e8"))}
            onClick={() => navigate(editUrl + data.id)}
          >
            <FontAwesomeIcon icon={faPen} />
          </button>
        ) : null}
        {deleteData ? (
          <button
            className="btn-modern"
            style={iconBtn(btn.iconSoft("#ffebee", "#c62828"))}
            onClick={() => deleteData(index, data)}
          >
            <FontAwesomeIcon icon={faTrash} />
          </button>
        ) : null}
      </div>
    </>
  );
};

export default EditCardButtons;
